(ns rothko.editor.actions
  (:refer-clojure :exclude [key])
  (:require #?@(:cljs ([cljs-time.core :as t]
                       [cljs-time.format :as tf]))
            [com.rpl.specter :as sp]
            [rothko.editor.matcher :as m])) ; TODO rothko#236

(defn key
  [key-map]
  {::type :key
   ::key key-map})

(def click {::type :click})

(def double-click {::type :double-click})

(defn button
  [button]
  {::type :button
   ::button {:name button}})

(def no-op (sp/terminal identity))

(def !transformations (atom []))

(defn enqueue-transformation!
  [transformation]
  (swap! !transformations conj transformation))

(defmulti ->transformation
  (fn [value]
    (m/dispatch ->transformation value)))

(defmethod ->transformation
  :default
  [_]
  nil)

(defn transformations!
  []
  (first (swap-vals! !transformations empty)))


;;; TODO: What is this↓ action log for?  It does not seem to be read anywhere!

(def action-log-limit 20)

(defonce !action-log (atom []))

(defn log-action!
  [action]
  (swap!
   !action-log
   (fn [log timestamp]
     (let [remove-count (- (inc (count log))
                           action-log-limit)]
       (cond-> (conj log (assoc action :timestamp timestamp))
         (pos? remove-count)
         (subvec remove-count))))
   #?(:cljs (-> tf/formatters :date-time (tf/unparse (t/now))))))
